const specificProviders = [
    'aol',
    'gmx',
    'google',
    'icloud',
    'kakao',
    'naver',
    'web',
    'yahoo'
]

export default {

    isSpecificProvider: function (provider) {
        return specificProviders.includes(provider ? provider.toLowerCase() : '')
    }

}
